import React, { useEffect } from 'react';
import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';
import dayGridPlugin from '@fullcalendar/daygrid';
import listPlugin from '@fullcalendar/list';
import { Box } from '@chakra-ui/react';
import Head from 'next/head';
import { createRef, useState } from 'react';
import deLocale from '@fullcalendar/core/locales/de';
import dayjs from 'dayjs';
import { dd, getUTCDate, makeApiRequest } from '@/components/helper';

/**
 * http://localhost:3000/deleteuser/kalender
 * http://localhost:3000/notexists/kalender
 * https://fullcalendar.io/docs/daygrid-view
 * https://fullcalendar.io/docs/Calendar-next
 * https://fullcalendar.io/docs/timeZone
 */
export default function Kalender({ companyId, response, error }) {
    const [slotMinTime, setSetSlotMinTime] = useState('12:00:00');
    const [slotMaxTime, setSetSlotMaxTime] = useState('24:00:00');
    const calendarRef = createRef();

    const initCalendar = appointments => {
        // get calendar api
        const api = calendarRef.current.getApi();
        // prepare for time calculations
        let allStartHours = [];
        let allEndHours = [];
        // add events
        appointments.map(item => {
            if (item.name === 'Freies Training') {
                return;
            }
            if (item.name === 'Freies Training ') {
                return;
            }
            if (item.name === 'Open Gym') {
                return;
            }

            let start = new Date(item.appointment);
            let end = addMinutes(start, item.duration);
            // allStartHours.push(start.getHours());
            allStartHours.push(start.getUTCHours());
            // allEndHours.push(end.getHours());
            allEndHours.push(end.getUTCHours());
            api.addEvent({
                // id: item.id,
                title: item.name,
                start: item.appointment,
                end: end.toISOString(),
                color: dayjs().isBefore(end) ? '#005078' : '#898989',
            });
        });

        // set starttime
        let timeStartString = getFirstTime(allStartHours);
        api.scrollToTime(timeStartString);
        setSetSlotMinTime(timeStartString);

        // sort endtime highest
        let timeEndString = getLastTime(allEndHours);
        setSetSlotMaxTime(timeEndString);
    };

    // initial once
    useEffect(() => {
        console.log('response', response);
        initCalendar(response);
    }, []);

    return (
        <div className="screenview">
            <Head>
                <title>{companyId} - Kalender</title>
                <meta name="robots" content="NOINDEX, NOFOLLOW" />
            </Head>
            <style jsx global>{`
                body.takeactive {
                    background: transparent;
                }

                .fc .fc-view-harness {
                    background: white;
                }

                .fc .fc-toolbar-title {
                    font-size: 1em;
                    color: #2d3748;
                    text-decoration: none;
                }

                :root {
                    --fc-button-text-color: #2d3748;

                    --fc-button-border-color: #edf2f7;
                    --fc-button-active-border-color: #edf2f7;

                    --fc-button-bg-color: #e7e7e7;
                    --fc-button-active-bg-color: #c1c1c1;

                    --fc-button-hover-bg-color: #c1c1c1;
                    --fc-button-hover-border-color: #edf2f7;
                }
            `}</style>
            <Box position="fixed" top="0" right="0" bottom="0" left="0">
                <FullCalendar
                    ref={calendarRef}
                    locale={deLocale}
                    validRange={{
                        start: dayjs().day(1).toDate(),
                        end: dayjs().add(3, 'weeks').day(0).toDate(),
                    }}
                    height={'100%'}
                    scrollTimeReset={false}
                    slotMinTime={slotMinTime}
                    slotMaxTime={slotMaxTime}
                    plugins={[dayGridPlugin, timeGridPlugin, listPlugin]}
                    headerToolbar={{
                        right: 'prev,next timeGridWeek,listWeek',
                        // right: 'prev,next timeGridDay,timeGridWeek,dayGridMonth,listWeek',
                    }}
                    initialView="timeGridWeek"
                    // now={new Date()}
                    now={getUTCDate()}
                    nowIndicator={true}
                    allDaySlot={false}
                    expandRows={true} // each row will bigger and setted to auto height
                    timeZone="UTC"
                    // timeZone="Europe/Berlin"
                />
            </Box>
        </div>
    );
}

function addMinutes(date, minutes) {
    var copiedDate = new Date(date.getTime());
    copiedDate.setMinutes(copiedDate.getMinutes() + minutes);
    return copiedDate;
}

export async function getServerSideProps(context) {
    const companyId = context.params.companyId;

    try {
        const response = await makeApiRequest(
            'GET',
            `/appointment/calendar/${companyId}`,
            null,
            false,
        );
        return { props: { companyId, response } };
    } catch (e) {
        return {
            notFound: true,
        };
    }
}

function getFirstTime(allStartHours) {
    // sort starttime lowest
    let timeStart = allStartHours.sort(function (a, b) {
        return a - b;
    });

    // no hours
    if (timeStart.length === 0) {
        return '00:00:00';
    }

    // first value parse
    timeStart = timeStart[0];

    // add 2 hours for better view
    timeStart = timeStart - 2;

    // if time is over 24, set to 24
    if (timeStart < 0) {
        timeStart = 0;
    }

    // format time
    let timeStartString = timeStart.toString().padStart(2, '0') + ':00';
    return timeStartString;
}

function getLastTime(allEndHours) {
    // sort endtime highest
    let timeEnd = allEndHours.sort(function (a, b) {
        return b - a;
    });

    // no hours
    if (timeEnd.length === 0) {
        return '24:00:00';
    }

    // mindnight is 0
    let lastValue = timeEnd[timeEnd.length - 1];
    if (lastValue === 0) {
        return '24:00:00';
    }

    // first value parse
    timeEnd = timeEnd[0];

    // add 2 hours for better view
    timeEnd = timeEnd + 2;

    // if time is over 24, set to 24
    if (timeEnd > 22) {
        timeEnd = 24;
    }

    // format time
    let timeEndString = timeEnd.toString().padStart(2, '0') + ':00';
    return timeEndString;
}
